import React, { useState, useContext, useEffect } from "react";
import { IntlProvider } from "react-intl";
import styled, { css } from "styled-components";

import PApromos from '../ingame/PAingame'

import { PAloginSBwidget, PAloginSBemail} from '../PAloginSBs';


// import PAloginSettings from '../login/PAloginSettings';

import PAloginSocials from '../PAloginSocials';
import PAloginStats from '../login/PAloginStats';

import PAtabs from '../PAtabs';

import { createBrowserHistory } from 'history';

import uniqid from 'uniqid';

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Head,
  Card,
  Radio,
  Input,
  RadioGroup,
  Switch,
  ImagePicker,
  FormCaption,
  Breadcrumbs,
  Icon,
  SidePanel,
  Textarea,
  ButtonAction,
  Tag,
  Notification,
  GroupSelect,
  ContentBlock,
  SelectMultiple,
} from "xsolla-uikit";

import {
  PAchart1,
  PAloginUsersFake,
  PAchartMap
} from "../PAcharts";
import {
  PAlogin0fake,
  PAloginSocialfake,

  PAchart1fake,
  PAchart2
} from "../PAchart2";

import PAusersSubscribers from "../support/PAusersSubscribers";

import CardNew from "../PAcardNew";
import { ContextConsumer } from "../../App";
import { Link } from "react-router-dom";

import merge from "deepmerge";

import SwitchExample from "../SwitchExample";
import PAContentBlock from "../PAContentBlock";


export default function PAsubs(
  {

    order = 1,
    id = 159428,
    sku = "gun_1",
    localized_name = "Xsolla Basic Blaster 1",
    prices = {
        "USD": 1.99
    },
    virtual_currency_price = null,
    default_currency = "USD",
    enabled = true,
    permanent = false,
    image_url = "\/\/cdn3.xsolla.com\/img\/misc\/images\/0c59a7698d4f66c1008b27ee752089b7.png",
    advertisement_type = null,



    name = "Xsolla Rocket Launcher",
    img =
    "https://res.cloudinary.com/maiik/image/upload/v1564043663/Xsolla_PA/temp/Frame_3.10.png",
    status = "active",
    hist,

}

) {


  const [action, setAction] = useState('cat');



  useEffect(() => {
    let newPage = hist.match.params.keyId;
    setAction(newPage)
    return () => {
    };
  }, [hist])


  return (

    <div className="xsui-content-block__entry">





      <div className="ui-table">
<div className="ui-table__head">
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '50%'}}>Plan name</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>Billing cycle</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>Subscription fee</div>
<div className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>Subscriptions</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>Status</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '5%'}} />
</div>
<div className="ui-table__body">
<div>
<div className="ui-table__body__row ui-table__body__row--v-align-top" data-id="table.rows[0]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '50%'}}>
<div className="table-rows__subscr__plan">
<div className="table-rows__subscr__plan__id">ID Ez200e6n</div>
<a className="table-rows__subscr__plan__name" aria-current="false" href="/15924/projects/37471/storefront/subscriptions/plans/241095">Xsolla Lifetime Subscription</a>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__bc">
<span>3 months</span>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__camount">$29.99</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__counters">
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-1" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--enabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.active">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-2" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--testing">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.Cancelled">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-3" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--disabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.non_renewing">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-4" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--deactivated">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.frozen">
<span>0</span>
</span>
</div>
</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="xsui-dropdown xsui-dropdown--autosize">
<div className="label label--secondary label--any-pointer" data-id="plan.status-switcher" data-value="enabled">
<div className="label__wrapper">
<div className="label__child">Enabled</div>
</div>
<div className="label__trigger">
<i className="xsui-icon xsui-icon-expand" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '5%'}}>
<div className="table-rows__subscr__actions">
<div className="xsui-dropdown xsui-dropdown--autosize">
<i data-id="plan.options" className="xsui-icon xsui-icon-more xsui-icon--hoverable" style={{fontSize: 24, color: 'inherit'}} />
<div />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-top" data-id="table.rows[1]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '50%'}}>
<div className="table-rows__subscr__plan">
<div className="table-rows__subscr__plan__id">ID jSedAgub</div>
<a className="table-rows__subscr__plan__name" aria-current="false" href="/15924/projects/37471/storefront/subscriptions/plans/243051">Xsolla Limited Subscription</a>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__bc">
<span>1 month</span>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__camount">$19.99</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__counters">
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-5" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--enabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.active">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-6" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--testing">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.Cancelled">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-7" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--disabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.non_renewing">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-8" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--deactivated">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.frozen">
<span>0</span>
</span>
</div>
</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="xsui-dropdown xsui-dropdown--autosize">
<div className="label label--secondary label--any-pointer" data-id="plan.status-switcher" data-value="enabled">
<div className="label__wrapper">
<div className="label__child">Enabled</div>
</div>
<div className="label__trigger">
<i className="xsui-icon xsui-icon-expand" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '5%'}}>
<div className="table-rows__subscr__actions">
<div className="xsui-dropdown xsui-dropdown--autosize">
<i data-id="plan.options" className="xsui-icon xsui-icon-more xsui-icon--hoverable" style={{fontSize: 24, color: 'inherit'}} />
<div />
</div>
</div>
</div>
</div>
<div className="ui-table__body__row ui-table__body__row--v-align-top" data-id="table.rows[2]">
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '50%'}}>
<div className="table-rows__subscr__plan">
<div className="table-rows__subscr__plan__id">ID pqwfqPfO</div>
<a className="table-rows__subscr__plan__name" aria-current="false" href="/15924/projects/37471/storefront/subscriptions/plans/243052">Xsolla Simple Subscription</a>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__bc">
<span>14 days</span>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__camount">$9.99</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="table-rows__subscr__counters">
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-9" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--enabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.active">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-10" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--testing">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.Cancelled">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-11" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--disabled">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.non_renewing">
<span>0</span>
</span>
</div>
</div>
</div>
<div className="xsui-tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-12" data-original-title="undefined" style={{display: 'inline'}}>
<div className="table-rows__subscr__counters__item">
<span className="table-rows__subscr__counters__item__status">
<div className="xsui-status-dot xsui-status-dot--deactivated">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>
</span>
<span data-id="plan.counter.frozen">
<span>0</span>
</span>
</div>
</div>
</div>
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '15%'}}>
<div className="xsui-dropdown xsui-dropdown--autosize">
<div className="label label--secondary label--any-pointer" data-id="plan.status-switcher" data-value="enabled">
<div className="label__wrapper">
<div className="label__child">Enabled</div>
</div>
<div className="label__trigger">
<i className="xsui-icon xsui-icon-expand" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
</div>
<div className="ui-table__column ui-table__column--indentation-sm" style={{maxWidth: '5%'}}>
<div className="table-rows__subscr__actions">
<div className="xsui-dropdown xsui-dropdown--autosize">
<i data-id="plan.options" className="xsui-icon xsui-icon-more xsui-icon--hoverable" style={{fontSize: 24, color: 'inherit'}} />
<div />
</div>
</div>
</div>
      </div>
</div>
</div>
</div>
</div>
  );
}






export const PAsubsPromos = ({}) => {
  return (
    <div className="ui-table">
      <div className="ui-table__head">
        <div
          className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
          style={{ maxWidth: "24%" }}
        >
          Promotion name
        </div>
        <div
          className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
          style={{ maxWidth: "20%" }}
        >
          Bonuses
        </div>
        <div
          className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
          style={{ maxWidth: "40%" }}
        >
          Periods
        </div>
        <div
          className="ui-table__column ui-table__column--indentation-sm"
          style={{ flexShrink: 0, width: 115 }}
        >
          Status
        </div>
        <div
          className="ui-table__column ui-table__column--separator ui-table__column--indentation-sm"
          style={{ maxWidth: "5%" }}
        />
      </div>
      <div className="ui-table__body">
        <div>
          <div
            className="ui-table__body__row ui-table__body__row--v-align-center"
            data-id="table.rows[0]"
          >
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "24%" }}
            >
              <div className="promotions-row__name">
                <div className="promotions-row__name__extra">
                  <a
                    className="promotions-row__name__extra__id"
                    aria-current="false"
                    href="/15924/projects/37471/storefront/promotions/19520"
                  >
                    ID 19520
                  </a>
                </div>
                <a
                  className="promotions-row__name__inner"
                  aria-current="false"
                  href="/15924/projects/37471/storefront/promotions/19520"
                >
                  Test promo
                </a>
              </div>
            </div>
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "20%" }}
            >
              <div className="promotions-row__bonuses">
                <div className="promotions-row__popover__bonuses__row">
                  -90% discount
                </div>
              </div>
            </div>
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "40%" }}
            >
              <div className="xsui-popover">
                <div className="promotions-row__periods">
                  <div className="promotions-row__periods__item promotions-row__periods__item--passed">
                    <div className="promotions-row__periods__item__date">
                      9/17/2019
                    </div>
                    <div className="promotions-row__periods__item__time">
                      1:06 PM
                    </div>
                  </div>
                  <div className="promotions-row__periods__item promotions-row__periods__item--passed">
                    <div className="promotions-row__periods__item__date">
                      9/17/2019
                    </div>
                    <div className="promotions-row__periods__item__time">
                      1:08 PM
                    </div>
                  </div>
                </div>
                <div className="promotions-row__periods">
                  <div className="promotions-row__periods__item promotions-row__periods__item--passed">
                    <div className="promotions-row__periods__item__date">
                      9/17/2019
                    </div>
                    <div className="promotions-row__periods__item__time">
                      1:07 PM
                    </div>
                  </div>
                  <div className="promotions-row__periods__item promotions-row__periods__item--passed">
                    <div className="promotions-row__periods__item__date">
                      9/18/2019
                    </div>
                    <div className="promotions-row__periods__item__time">
                      12:00 PM
                    </div>
                  </div>
                </div>
                <div />
              </div>
            </div>
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ flexShrink: 0, width: 115 }}
            >
              <div className="promotions-row__status">
                <div className="xsui-dropdown">
                  <div className="xsui-pill xsui-pill--appearance-active xsui-pill--clickable">
                    <div className="xsui-pill__wrapper">
                      <div className="xsui-pill_entry">On</div>
                    </div>
                    <div className="xsui-pill_trigger xsui-pill_trigger--separated">
                      <i
                        className="xsui-icon xsui-icon-expand"
                        style={{ fontSize: 24, color: "inherit" }}
                      />
                    </div>
                  </div>
                  <div />
                </div>
              </div>
            </div>
            <div
              className="ui-table__column ui-table__column--indentation-sm"
              style={{ maxWidth: "5%" }}
            >
              <div className="promotions-row__actions">
                <div style={{ width: 24, height: 24 }}>
                  <div className="xsui-dropdown">
                    <i
                      className="xsui-icon xsui-icon-more xsui-icon--hoverable"
                      style={{ fontSize: 24, color: "rgb(116, 126, 138)" }}
                    />
                    <div />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

